import { Alert, Link } from 'omakase';
import { MobileNativeContext } from 'providers/withApplicationContext';
import { Theme, css } from '@emotion/react';
import { isIOSNative } from 'utils/deviceUtils';
import { useFeatureFlagForConsumer } from 'featureFlags/useConsumerFeatureFlag';
import React from 'react';

const AndroidDecomAlert: React.FunctionComponent = () => {
  const isReactNativeApp = React.useContext(MobileNativeContext).reactNative;
  const isAndroidDecomAlertEnabled = useFeatureFlagForConsumer('CONSUMER_ANDROID_DECOM_BANNER');
  return isReactNativeApp && isAndroidDecomAlertEnabled && !isIOSNative() ? (
    <div
      css={({ spacing }: Theme) => css`
        margin-top: ${spacing(7)}px;
      `}
    >
      <Alert severity="error" icon={false}>
        The Tock Android app will no longer be available starting July 2, 2026. You can still browse
        and book at{' '}
        <Link target="_blank" href="https://www.exploretock.com" rel="noopener noreferrer">
          exploretock.com
        </Link>{' '}
        in your mobile browser.
      </Alert>
    </div>
  ) : null;
};

export default AndroidDecomAlert;
